export default __webpack_public_path__ + "static/media/redis.3933a99b.svg";